import { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebaseConfig";

export function useMonthlyReportData(month, year) {
  const [transactions, setTransactions] = useState([]);
  const [privateEvents, setPrivateEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      setLoading(true);
      setErr("");
      try {
        const [txnSnap, eventSnap] = await Promise.all([
          getDocs(
            query(
              collection(db, "transactions"),
              where("Month", "==", month),
              where("Year", "==", year)
            )
          ),
          getDocs(
            query(
              collection(db, "privateEvents"),
              where("month", "==", month),
              where("year", "==", year)
            )
          ),
        ]);

        let fetchedTx = txnSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
        let fetchedEvents = eventSnap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));

        fetchedTx = fetchedTx.sort(
          (a, b) => new Date(`${a.Date} ${a.Time}`) - new Date(`${b.Date} ${b.Time}`)
        );
        fetchedEvents = fetchedEvents.sort(
          (a, b) => new Date(a.startTime) - new Date(b.startTime)
        );

        if (!cancelled) {
          setTransactions(fetchedTx);
          setPrivateEvents(fetchedEvents);
        }
      } catch (e) {
        console.error("Error fetching monthly report data:", e);
        if (!cancelled) setErr("Failed to load data. Please try again.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchData();
    return () => {
      cancelled = true;
    };
  }, [month, year]);

  return {
    transactions,
    setTransactions,
    privateEvents,
    setPrivateEvents,
    loading,
    err,
  };
}

